
import {
	getSession,
} from 'Vulture/Session.js';

import {
	broncoURL,
} from './ENV';

export const slideDeckDeleteValidation = async (slideDeckID, accountUUID) => {
	const url = `${broncoURL}/slide_deck/${slideDeckID}/validate_delete/${accountUUID}`;
	const sessionKey = getSession().session;

	return await fetch(url, {
		method:  'GET',
		headers: {
			'Content-Type':   'application/json',
			'X-Auth-Session': sessionKey,
		},
	})
		.then((data) => {
			return data.json();
		});
};